<template>
  <div
    ref="mainForm"
    class="compare-field scroll_bar_beautify_ff"
  >
    <a-form
      v-if="fields"
      :form="form"
      class="config-form"
      @submit.prevent="handleSubmit"
    >
      <div class="header">
        <span>{{ $t('message["1237"]') }} INPUT NAME/VALUE</span>
        <span>{{ $t('message["259"]') }}</span>
      </div>
      <ul
        v-if="fields.length"
        class="fields"
      >
        <li
          v-for="(field, i) in fields"
          v-show="!field.fielddelete"
          :key="field._id"
          class="item"
          :class="{ 'close': !field.open }"
        >
          <div class="top clearfix">
            <i
              v-if="(field.fieldtype !== 'editor' && field.fieldtype !== 'file') && field.options && field.options.length"
              class="iconfont open-close"
              :class="{ 'iconicon-test9': !field.open, 'iconicon-test11': field.open }"
              @click="handleFieldOpen(field)"
            />
            <a-form-item>
              <div class="wrap">
                <a-input
                  :ref="`${field.fieldkey}.remotekey.${i}`"
                  v-decorator="[`${field.fieldkey}.remotekey.${i}`, {
                    validateTrigger: [],
                    rules: [{
                      required: true,
                      message: ' '
                    }, {
                      validator: checkFieldRemotekey
                    }],
                    initialValue: field.remotekey
                  }]"
                  :placeholder="enterPlaceholder"
                  class="out-input"
                  @change="handleFieldInput($event, field, i)"
                  @blur="onBlurField(field, i)"
                />
              </div>
            </a-form-item>
            <a-form-item>
              <a-select
                v-decorator="[`${field.fieldkey}.xg`, {
                  rules: [{
                    required: true,
                    message: ' '
                  }, {
                    validator: checkFieldKey
                  }],
                  initialValue: field.fieldkey
                }]"
                allow-clear
                :show-search="true"
                :filter-option="filterOption"
                dropdown-class-name="universalformXgSelect"
                :placeholder="selectPlaceholder"
                @change="handleTypeChange($event, i)"
              >
                <a-select-opt-group
                  v-for="modules in allConfigs"
                  :key="modules.fieldkey"
                >
                  <span
                    v-if="modules.fieldname"
                    slot="label"
                  >{{ modules.fieldname }}</span>
                  <a-select-option
                    v-for="item in modules.child"
                    :key="item.fieldkey"
                    :value="item.fieldkey"
                  >
                    {{ item.fieldname }}<span v-if="item.fieldtypename">[{{ item.fieldtypename }}]</span>
                  </a-select-option>
                </a-select-opt-group>
              </a-select>
            </a-form-item>
            <config-tooltip
              v-if="field.fieldkey === 'universal_form_filed_ignore'"
              :text="configTooltip"
            />
            <span
              v-if="field.optionMsg"
              class="option-msg"
            ><i class="iconfont iconicon-test34" /> {{ field.optionMsg }}</span>
            <i
              class="iconfont iconicon-test8 delete-field-btn"
              @click="handleDeleteField(i, field)"
            />
          </div>
          <div
            v-show="field.open && !(field.fieldtype === 'file' || field.fieldtype === 'editor' || field.fieldkey === 'universal_form_filed_ignore')"
            class="options-list"
          >
            <p
              v-for="(one, j) in field.options"
              :key="one._id"
              class="one clearfix"
            >
              <a-form-item>
                <div
                  :ref="`${field.fieldkey}.optionRow${i}.${j}.remote`"
                  v-decorator="[`${field.fieldkey}.optionRow${i}.${j}.remote`, {
                    validateTrigger: ['change', 'blur'],
                    rules: [{
                      validator: checkFieldOptionsRemote
                    }],
                    initialValue: one.remote
                  }]"
                  class="wrap"
                >
                  <a-input
                    :value="one.remote"
                    :placeholder="enterPlaceholder"
                    class="remote-input"
                    @change="handleInputRemote($event, field, one, i, j)"
                  />
                </div>
              </a-form-item>
              <span class="transfer-icon"> <i class="iconfont iconicon-test89 " /> </span>
              <a-form-item>
                <div
                  v-decorator="[`${field.fieldkey}.optionRow${i}.${j}.xg`, {
                    validateTrigger: ['change'],
                    rules: [{
                      validator: checkFieldOptionsXg
                    }],
                    // initialValue: one.textname || one.fieldid + ''
                    initialValue: field.fieldtype === 'datetime' ? (moment(one.textname, field.fieldconfig && field.fieldconfig.formatdatetime === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm') || {}) : (one.textname || one.fieldid + '')
                  }]"
                  class="wrap"
                >
                  <a-select
                    v-if="field.fieldtype === 'select' || field.fieldtype === 'radio' || field.fieldtype === 'checkbox'"
                    :ref="`${field.fieldkey}.optionRow${i}.${j}.xg`"
                    :default-value="one.fieldid"
                    :show-search="true"
                    :filter-option="filterOption"
                    :placeholder="selectPlaceholder"
                    @change="changeOptionOne($event, field, one, i, j)"
                  >
                    <a-select-option
                      v-for="option in field.selectList"
                      :key="option.id"
                      :value="option.id"
                    >
                      {{ option.name }}
                    </a-select-option>
                  </a-select>

                  <a-tree-select
                    v-else-if="field.fieldtype === 'select_tree'"
                    :default-value="one.fieldid"
                    :tree-data="field.selectList"
                    :placeholder="selectPlaceholder"
                    show-search
                    tree-default-expand-all
                    tree-node-filter-prop="title"
                    @change="changeOptionOne($event, field, one, i, j)"
                  />
                  <a-date-picker
                    v-else-if="field.fieldtype === 'datetime'"
                    :show-time="field.fieldconfig && field.fieldconfig.formatdatetime === 2"
                    :format="field.fieldconfig && field.fieldconfig.formatdatetime === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'"
                    :value="one.textname ? moment(one.textname, field.fieldconfig && field.fieldconfig.formatdatetime === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm') : null"
                    dropdown-class-name="my-data-picker"
                    @change="changeOptionOne($event, field, one, i, j)"
                    @ok="changeOptionOne($event, field, one, i, j)"
                  />
                  <a-input
                    v-else
                    :value="one.textname"
                    :placeholder="enterPlaceholder"
                    class="xg-input"
                    @change="changeOptionOne($event, field, one, i, j)"
                  />
                </div>
              </a-form-item>
              <i
                class="iconfont iconicon-test8 delete-option-btn"
                @click="handleDeleteOption(i, j, one)"
              />
            </p>
            <a
              href="javascript:;"
              class="add-option-btn"
              @click="handleAddOption(i)"
            >
              {{ $t('message["1192"]') }}</a>
          </div>
        </li>
      </ul>
      <a
        href="javascript:;"
        class="add-field-btn"
        @click="handleAddField"
      >{{ $t('message["1190"]') }}</a>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
import { getH } from '@/store/universalForm/convert'
import ConfigTooltip from './ConfigTooltip'

export default {
  components: {
    ConfigTooltip
  },
  data () {
    return {
      form: this.$form.createForm(this),
      devMemberList: [],
      currentField: {},
      currentOption: {},
      checkKeys: []
    }
  },

  computed: {
    ...mapState('universalForm/outform', ['formData', 'confrimConfig', 'configFormError', 'compareFieldError', 'result']),
    allConfigs () {
      const { allConfig = {} } = this.formData || {}
      let ignores = {
        fieldkey: 'ignores',
        fieldname: '',
        child: [{
          fieldkey: 'universal_form_filed_ignore',
          fieldtype: 'universal_form_filed_ignore',
          fieldname: `-${this.$t('message["437"]')}-`,
          fieldtypename: ''
        }]
      }
      return {
        ignores,
        ...allConfig
      }
    },

    allConfigList () {
      const { allConfigs = {} } = this
      let arr = []
      for (let k in allConfigs) {
        let modules = allConfigs[k] || {}
        // console.log(modules.child)
        for (let j in modules.child) {
          let item = modules.child[j]
          if (item.fieldtype === 'area') {
            item.options = []
          }
          arr.push(item)
        }
      }
      return arr
    },
    fields () {
      if (!this.formData) return
      const fields = this.formData.config || []
      for (let index in fields) {
        let item = fields[index]
        this.$set(item, '_id', Math.random())
        this.$set(item, 'open', true)
        if (item.fielddelete === undefined) {
          this.$set(item, 'fielddelete', false)
        }
        if (item.fieldkey === 'universal_form_filed_ignore') {
          item.fieldname = `-${this.$t('message["437"]')}-`
        }
        if (item.remotekey === undefined) {
          this.$set(item, 'remotekey', '')
        }
        if (!item.options) {
          this.$set(item, 'options', [])
        }

        if (this.allConfigList && this.allConfigList.length) {
          for (let one of this.allConfigList) {
            if (item.fieldkey === one.fieldkey && one.options) {
              // console.log(one.options)
              for (let option of one.options) {
                option.id = option.id + ''
              }
              item.fieldconfig = one.fieldconfig
              item.selectList = JSON.parse(JSON.stringify(one.options))

              if (item.fieldtype === 'select_tree') {
                item.allSelectList = []
                this.setOptions(item.selectList, item.allSelectList)
              }
            }
          }
        }

        if (!item.fieldtype && item.fieldkey !== 'universal_form_filed_ignore') {
          item.fieldkey = undefined
        }

        if (item.options && item.options.length) {
          for (let option of item.options) {
            if (item.fieldkey === '') {
              option._id = Math.random()
              option.fieldid = ''
            } else if (option.fieldid === 0) {
              option._id = Math.random()
              option.fieldid = ''
            } else {
              option.fieldid = option.fieldid + ''
            }
            if (item.fieldtype === 'datetime') {
              // console.log(moment(option.textname, item.fieldconfig && item.fieldconfig.formatdatetime === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'))
              // option.textname = moment(option.textname, item.fieldconfig && item.fieldconfig.formatdatetime === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm')
            }

            let selectList = item.selectList || []
            if (item.fieldtype === 'select_tree') {
              selectList = item.allSelectList || []
            }
            let filters = selectList.filter(one => option.fieldid && option.fieldid + '' === one.id + '')
            // console.log(selectList, filters, item.fieldtype)
            if ((selectList.length && !filters.length) || item.fieldtype === 'editor' || item.fieldtype === 'file') {
              option.fieldid = ''
              option.name = ''
              option.textname = ''
            }
          }
        }
      }

      return fields
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    configTooltip () {
      return this.$t('message["1026"]')
    }
  },

  created () {
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true })
    // console.log(allFieldType)
    this.$nextTick(() => {
      let $main = this.$refs.mainForm
      getH($main, 160)
    })
  },

  methods: {
    ...mapMutations('universalForm/outform', ['setFieldsConfig', 'setCompareFieldError']),
    moment,
    handleFieldOpen (field) {
      this.$set(field, 'open', !field.open)
    },
    handleFieldInput (e, field, i) {
      let val = e.target.value || ''

      this.fields[i].remotekeynew = this.trim(val)
      // console.log(field.remotekey)
      this.currentField = field

      /* if (val === '') {
        let resultFlag = false
        this.checkAll(this, resultFlag)
      } */
    },
    onBlurField (field, i) {
      field.remotekey = this.fields[i].remotekeynew === undefined ? field.remotekey : this.fields[i].remotekeynew

      /* let flag = false
      let _this = this

      for (let k in this.fields) {
        let one = this.fields[k];
        (function (i) {
          setTimeout(() => {
            _this.form.setFieldsValue({
              [`${one.fieldkey}.remotekey.${k}`]: one.remotekey
            })
            _this.form.validateFields([`${one.fieldkey}.remotekey.${k}`], (err, values) => {
              flag = flag || !!err
              _this.setCompareFieldError(flag)
            })
          }, 0)
        })(i)
      } */
      let resultFlag = false
      this.checkAll(this, resultFlag)
    },

    handleTypeChange (value, i) {
      let fieldkey = value
      let field = this.formData.config[i]

      for (let k in this.allConfigList) {
        let item = this.allConfigList[k]
        item.options = item.options || []
        if (fieldkey === item.fieldkey) {
          field.fieldkey = fieldkey
          field.fieldtype = item.fieldtype
          field.fieldname = item.fieldname
          field.selectList = JSON.parse(JSON.stringify(item.options))
          if (!field.options) {
            this.$set(field, 'options', [])
          }
          /* if (field.fieldtype === 'select_tree') {
            field.allSelectList = []
            this.setOptions(field.selectList, field.allSelectList)
          } */
        }
      }

      // 切换对应关系的fieldkey时，如果子级之前选择过，清空右侧数据fieldid/textname
      /* if (field.options) {
        let selectList = []
        selectList = field.selectList || []
        if (field.fieldtype === 'select_tree') {
          selectList = field.allSelectList || []
        }
        for (let option of field.options) {
          let filters = selectList.filter(one => option.fieldid && option.fieldid + '' === one.id + '')
          // console.log(field.fieldtype, )
          if (!filters.length || field.fieldtype === 'editor' || field.fieldtype === 'file') {
            option.fieldid = ''
            option.name = ''
            option.textname = ''
          }
        }
      } */

      /* this.$nextTick(() => {
        this.form.setFieldsValue({
          [`${field.fieldkey}.remotekey.${i}`]: field.remotekey
        })
        this.form.validateFields([`${field.fieldkey}.remotekey.${i}`], (err, values) => {
          this.setCompareFieldError(!!err)
        })

        if (field.options) {
          for (let j in field.options) {
            let one = field.options[j]
            this.form.setFieldsValue({
              [`${field.fieldkey}.optionRow${i}.${j}.xg`]: (one.textname || one.fieldid),
              [`${field.fieldkey}.optionRow${i}.${j}.remote`]: one.remote
            })
            this.form.validateFields([`${field.fieldkey}.optionRow${i}.${j}.xg`, `${field.fieldkey}.optionRow${i}.${j}.remote`], (err, values) => {
              // console.log(err, values)
              this.setCompareFieldError(!!err)
            })
          }
        }
      }) */
      let resultFlag = false
      this.checkAll(this, resultFlag)
    },
    checkFieldRemotekey (rule, value, callback) {
      // console.log('remotekey', value)
      value = this.trim(value)
      if (value !== '' && value !== undefined) {
        let filters = this.formData.config && this.formData.config.filter(item => item.remotekey === value)
        if (filters.length >= 2) {
          callback(new Error(this.$t('message["1650"]')))
          this.setCompareFieldError(true)
        } else {
          callback()
        }
      } else {
        callback(new Error(this.$t('message["811"]') + 'key'))
        this.setCompareFieldError(true)
      }
    },
    checkFieldKey (rule, value, callback) {
      // console.log('fieldkey', value)
      value = this.trim(value)
      if (value !== '' && value !== undefined) {
        callback()
      } else {
        callback(new Error(this.$t('message["858"]')))
        this.setCompareFieldError(true)
      }
    },
    filterOption (input, option = {}) {
      let { componentOptions = {} } = option
      let { children = [] } = componentOptions
      let { text = '' } = children[0]
      return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleAddOption (i) {
      let field = this.formData.config[i]
      const { fieldtype } = field
      if (fieldtype === 'select' || fieldtype === 'radio' || fieldtype === 'select_tree' || fieldtype === 'checkbox') {
        field.options.push({
          fieldid: '',
          name: '',
          remote: ''
        })
      } else {
        field.options.push({
          fieldid: 0,
          textname: '',
          remote: ''
        })
      }
      let resultFlag = false
      this.checkAll(this, resultFlag)
    },
    handleAddField () {
      let obj = {
        fieldkey: undefined,
        fieldname: '',
        fieldtype: '',
        remotekey: '',
        options: []
      }
      let filters = this.formData.config && this.formData.config.filter(item => (!item.fieldkey || this.remotekey === ''))
      if (filters.length) {
        for (let i in this.formData.config) {
          let field = this.formData.config[i]
          this.form.validateFields([`${field.fieldkey}.xg`])
          this.form.validateFields([`${field.fieldkey}.remotekey.${i}`])
        }
        this.setCompareFieldError(true)
      } else {
        this.formData.config.push(obj)
      }
    },
    handleDeleteField (i, field) {
      let _this = this
      this.$confirm({
        title: this.$t('message["925"]') + '？',
        content: this.$t('message["970"]') + '？',
        /* title: '<h2>确定要删除当前对应外部表单字段吗？</h2><div>删除后，提交记录中该字段下内容将无法和<span style="color:red;">将无法和 星轨中的字段对应</span>，但是不会影响数据提交， 你还要继续吗？</div>', */
        // content: h => <div>删除后，提交记录中该字段下内容将无法和<span style="color:red;">将无法和 星轨中的字段对应</span>，但是不会影响数据提交， 你还要继续吗？</div>,
        okText: this.$t('message["466"]'),
        okType: 'primary',
        cancelText: this.$t('message["896"]'),
        onOk () {
          /* for (let index in _this.formData.config) {
            let item = _this.formData.config[index]
            if (field._id === item._id) {
              // _this.formData.config.splice(i, 1)
              _this.$delete(_this.formData.config, index)
            }
          } */
          field.fielddelete = true
          _this.formData.config.splice(i, 1, field)
        },
        onCancel () {
          // console.log('Cancel')
        },
        class: 'test'
      })
    },
    handleDeleteOption (i, j, one) {
      let field = this.formData.config[i]
      let _this = this
      this.$confirm({
        title: this.$t('message["924"]') + '？',
        content: '',
        okText: this.$t('message["466"]'),
        okType: 'primary',
        cancelText: this.$t('message["896"]'),
        onOk () {
          /* for (let i in field.options) {
            const item = field.options[i]
            if (item.fieldkey === one.fieldkey) {
              field.options.splice(i, 1)
            }
          } */
          field.options.splice(j, 1)

          let resultFlag = false
          _this.checkAll(_this, resultFlag)
        },
        onCancel () {
          // console.log('Cancel')
        }
      })
    },
    handleInputRemote (e, field, one, i, j) {
      let val = e.target.value
      one.remote = this.trim(val)
      this.currentField = field
      this.currentOption = one

      this.$nextTick(() => {
        this.form.setFieldsValue({
          [`${field.fieldkey}.optionRow${i}.${j}.remote`]: one.remote
        })
        this.form.validateFields([`${field.fieldkey}.optionRow${i}.${j}.remote`], (err, values) => {
          this.setCompareFieldError(!!err)
        })
      })
    },
    changeOptionOne (val, field, one, i, j) {
      if (field.fieldtype === 'select' || field.fieldtype === 'select_tree' || field.fieldtype === 'radio' || field.fieldtype === 'checkbox') {
        one.fieldid = val
      } else if (field.fieldtype === 'datetime') {
        one.textname = moment(val).format(field.fieldconfig && field.fieldconfig.formatdatetime === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm')
      } else {
        let input = val.target.value
        one.textname = this.trim(input)
      }

      this.currentField = field
      this.currentOption = one

      let flag = false
      let _this = this
      for (let o in field.options) {
        let option = field.options[o];
        (function (i, o) {
          setTimeout(function () {
            _this.form.setFieldsValue({
              [`${field.fieldkey}.optionRow${i}.${o}.xg`]: (option.textname || option.fieldid),
              [`${field.fieldkey}.optionRow${i}.${o}.remote`]: option.remote
            })
            _this.form.validateFields([`${field.fieldkey}.optionRow${i}.${o}.xg`, `${field.fieldkey}.optionRow${i}.${o}.remote`], (err, values) => {
              // console.log(err, values)
              flag = flag || !!err
              _this.setCompareFieldError(flag)
            })
          }, 300)
        })(i, o)
      }
    },
    checkFieldOptionsRemote (rule, value, callback) {
      // console.log('optionRemote', value)
      value = this.trim(value)
      if (value !== '' && value !== undefined) {
        let filters = (this.currentField.options && this.currentField.options.filter(item => item.remote === value)) || []
        if (filters.length >= 2) {
          callback(new Error(this.$t('message["1221"]')))
          this.setCompareFieldError(true)
        } else {
          callback()
        }
      } else {
        callback(new Error(this.$t('message["749"]')))
        this.setCompareFieldError(true)
      }
    },
    checkFieldOptionsXg (rule, value, callback) {
      // console.log('xg', value)
      value = this.trim(value)
      if (value !== '' && value !== undefined && value !== 'Invalid date') {
        let filters = this.currentField.options && this.currentField.options.filter(item => item.remote === value)
        if (filters.length >= 2) {
          callback(new Error(this.$t('message["1221"]')))
          this.setCompareFieldError(true)
        } else {
          callback()
        }
      } else {
        callback(new Error(this.$t('message["749"]')))
        this.setCompareFieldError(true)
      }
    },
    setOptions (options, allSelectList) {
      for (let item of options) {
        item.title = item.name
        // item.value = item.pId + '-' + item.id
        item.id = item.id + ''
        item.value = item.id
        item.key = item.pId + '-' + item.id
        allSelectList.push(item)
        // item.allSelectList = allSelectList
        if (item.children || item.child) {
          item.children = item.children || item.child || []
          for (let child of item.children) {
            child.pId = item.pId + '-' + item.id
            child.pName = item.pName + '/' + item.name
          }
          this.setOptions(item.children, allSelectList)
        }
      }
    },
    trim (val) {
      return val.replace(/(^\s*)|(\s*$)/g, '')
    },
    checkAll (_this, resultFlag) {
      // 验证没有添加对应关系的行
      let filters = _this.formData.config && _this.formData.config.filter(item => {
        let flag = !item.fieldkey || _this.remotekey === ''

        let requireType = item.fieldtype === 'radio' || item.fieldtype === 'select_tree' || item.fieldtype === 'select' || item.fieldtype === 'checkbox'

        if (requireType && !item.options.length) {
          flag = true
        }
        if (flag) {
          _this.$set(item, 'optionMsg', this.$t('message["847"]'))
        } else {
          _this.$set(item, 'optionMsg', '')
        }
        return flag
      })
      if (filters.length) {
        resultFlag = true
        _this.setCompareFieldError(resultFlag)
      }

      for (let i in _this.formData.config) {
        let field = _this.formData.config[i]

        _this.checkKeys.push(`${field.fieldkey}.remotekey.${i}`)
        _this.checkKeys.push(`${field.fieldkey}.xg`);

        // 验证左侧的remotekey是否重复
        (function (i) {
          setTimeout(() => {
            _this.currentField = field
            _this.form.setFieldsValue({
              [`${field.fieldkey}.remotekey.${i}`]: field.remotekey
            })
            _this.form.validateFields([`${field.fieldkey}.remotekey.${i}`], (err, values) => {
              resultFlag = resultFlag || !!err
              _this.setCompareFieldError(resultFlag)
            })
          }, 0)
        })(i)

        // 验证子集option
        if (field.options) {
          for (let j in field.options) {
            let one = field.options[j]
            _this.checkKeys.push(`${field.fieldkey}.optionRow${i}.${j}.remote`)
            _this.checkKeys.push(`${field.fieldkey}.optionRow${i}.${j}.xg`);

            (function (i, j) {
              setTimeout(function () {
                _this.form.setFieldsValue({
                  [`${field.fieldkey}.optionRow${i}.${j}.remote`]: one.remote,
                  [`${field.fieldkey}.optionRow${i}.${j}.xg`]: (one.textname || one.fieldid)
                })

                _this.form.validateFields([`${field.fieldkey}.optionRow${i}.${j}.remote`, `${field.fieldkey}.optionRow${i}.${j}.xg`], (err, values) => {
                  resultFlag = resultFlag || !!err
                  _this.setCompareFieldError(resultFlag)
                })
              }, 0)
            })(i, j)
          }
        }
      }
    },
    handleSubmit () {
      // this.setCompareFieldError(true)
      let _this = this
      let resultFlag = false
      this.checkKeys = []

      return new Promise(function (resolve, reject) {
        _this.checkAll(_this, resultFlag)

        let filterRes = _this.fields.filter(field => !field.fielddelete)
        _this.setFieldsConfig(filterRes)
        // console.log(_this.checkKeys)

        setTimeout(function () {
          _this.form.validateFields(_this.checkKeys, async (err, values) => {
            // console.log(err, values)
            if (resultFlag || err) {
              _this.setCompareFieldError(true)
            } else {
              _this.setCompareFieldError(false)
              resolve(true)
            }
          })
        }, 10)
      })
      // })
    }
  }
}
</script>
<style lang="scss" scoped>
.compare-field {
  overflow-y: auto;
  padding: 16px 24px;
  .header {
    height: 48px;
    line-height: 48px;
    margin-bottom: 12px;
    background: rgba(245, 246, 247, 1);
    border-radius: 4px 0px 0px 4px;
    span {
      display: inline-block;
      padding: 0 16px;
    }
    span:first-child {
      width: 400px;
    }
    span:last-child {
      width: 560px;
    }
  }
  li.item {
    /* &.close:hover {
      background: rgba(244, 247, 249, 1);
    } */
    padding-bottom: 36px;
    border-bottom: solid 1px #ebebeb;
    &:hover .top {
      background: rgba(244, 247, 249, 1);
    }
    .top {
      position: relative;
      padding: 12px 0 12px 40px;
      .ant-row {
        float: left;
        margin-bottom: 0;
      }
      .open-close {
        position: absolute;
        top: 20px;
        left: 16px;
        z-index: 2;
        height: 16px;
        line-height: 16px;
        font-size: 16px;
        color: #d6d6d6;
        cursor: pointer;
      }
      .out-input {
        width: 320px;
        margin: 0 56px 0 0;
      }
      .delete-field-btn {
        float: right;
        margin-right: 24px;
        color: #d6d6d6;
      }
    }
    .options-list {
      margin: 12px 0;
      .one {
        margin-bottom: 24px;
        padding-left: 40px;
      }
      .ant-row {
        float: left;
        margin-bottom: 0;
      }
      .remote-input {
        width: 320px;
      }
      .transfer-icon {
        float: left;
        // display: inline-block;
        width: 56px;
        text-align: center;
        color: #d6d6d6;
      }
      .delete-option-btn {
        margin-left: 16px;
        color: #d6d6d6;
      }
    }
    .add-option-btn {
      padding-left: 40px;
      font-size: 14px;
      color: #5077aa;
    }
  }
  .option-msg {
    height: 30px;
    line-height: 30px;
    margin-left: 16px;
    color: #f57676;
  }
  .ant-calendar-picker {
    width: 320px !important;
  }
  .add-field-btn {
    display: block;
    width: 696px;
    height: 32px;
    margin: 12px 0 0 40px;
    font-size: 14px;
    text-align: center;
    color: rgba(80, 119, 170, 1);
    line-height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px dashed rgba(214, 214, 214, 1);
  }

  .tooltip-btn {
    margin-left: 12px;
    height: 32px;
    line-height: 32px;
    color: #d6d6d6;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.my-data-picker {
  .ant-calendar-time-picker-combobox {
    height: 226px;
    overflow: hidden;
  }
  .ant-calendar-time-picker-select {
    width: 50%;
    &:nth-child(2) {
      border: none;
    }
  }
}
/* 万能表单 下拉内的忽略选项隐藏 */
.ant-select-dropdown.universalformXgSelect {
  .ant-select-dropdown-menu-item-group-title[title='ignores'] {
    display: none;
  }
}
</style>
